(() => {
  'use strict';
  if (window.pcGrowthLoaded) return;
  window.pcGrowthLoaded = true;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const publish = (name, data = {}) => {
    if (!allowed() || window.Shopify?.designMode) return false;
    try {
      if (typeof window.Shopify?.analytics?.publish !== 'function') return false;
      window.Shopify.analytics.publish('patagonia:' + name, {page: location.pathname, ...data});
      return true;
    } catch { return false; }
  };
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => { if (!error) completed(); });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-dose-calculate]');
    if (button) {
      const root = button.closest('[data-pc-dose]');
      const cups = root.querySelector('[data-dose-cups]');
      const grams = root.querySelector('[data-dose-grams]');
      const output = root.querySelector('[data-dose-result]');
      const copy = JSON.parse(root.querySelector('[data-dose-copy]').textContent);
      const valid = cups.checkValidity() && grams.checkValidity() && cups.value !== '' && grams.value !== '';
      if (!valid) {
        output.textContent = copy.error;
        if (!cups.reportValidity()) return;
        grams.reportValidity();
        return;
      }
      const daily = cups.valueAsNumber * grams.valueAsNumber;
      const format = new Intl.NumberFormat(document.documentElement.lang || 'fr', {maximumFractionDigits: 1});
      const values = {small: format.format(500 / daily), large: format.format(1000 / daily), monthly: format.format(daily * 30 / 1000)};
      output.textContent = copy.result.replace(/\{(small|large|monthly)\}/g, (_, key) => values[key]);
      publish('coffee_estimate_used');
    }
    if (event.target.closest('#pc-enterprise-2026 a[href="#degustation"]')) publish('tasting_cta_clicked');
    if (event.target.closest('[data-open-composer]')) publish('subscription_composer_opened');
  });
  let started = false;
  document.addEventListener('input', event => {
    if (!started && event.target.closest('#pc-enterprise-contact-form')) started = publish('tasting_form_started');
  });
  document.addEventListener('submit', event => {
    if (event.target.id === 'pc-enterprise-contact-form') {
      if (allowed()) {
        try { sessionStorage.setItem('pc-tasting-pending', String(Date.now())); } catch {}
      }
      publish('tasting_form_attempted');
    }
  });
  function completed() {
    if (!document.querySelector('[data-pc-tasting-success]') || !allowed()) return;
    try {
      const pending = Number(sessionStorage.getItem('pc-tasting-pending'));
      if (pending && Date.now() - pending < 1800000 && publish('tasting_form_succeeded')) sessionStorage.removeItem('pc-tasting-pending');
    } catch {}
  };
  document.addEventListener('visitorConsentCollected', completed);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', completed, {once: true});
  else completed();
})();
